import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormFields } from '../../AccountForm.meta';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';

const MAX_YEARS = 41;

export const AnnuityPurchaseYear = () => {
  const { control, setValue } = useFormContext<FormFields>();

  const { usageContext } = useAccountFormContext();

  if (usageContext === AccountModalUsageContext.AnnuityPurchaseWhatIf) {
    return null;
  }

  const currentYear = new Date().getFullYear();

  const options = [...Array(MAX_YEARS)].map((_, i) => {
    const year = (currentYear - i).toString();
    return { label: year, value: year };
  });

  return (
    <>
      <Controller
        control={control}
        name="bankAccount.AnnuityPurchaseYear"
        render={({ field: { value, onChange, ...field } }) => (
          <Select
            {...field}
            value={options.find(option => option.value === value?.toString()) ?? options[0]}
            options={options}
            onChange={opt => {
              onChange(opt?.value);
              setValue('bankAccount.AnnuityLivingBenefitRider.IncomeStartYear', 0);
            }}
            label="Purchase Year"
            placeholder="Select Purchase Year"
            isPortal
          />
        )}
      />
    </>
  );
};
